<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage"
         [ngStyle]="{width: passOnLogService.showDetailedView ? 'calc(100% - 420px)' : ''}">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Pass On Log'" [buildings]="passOnLogService.buildingsForRead"></filter>
                </div>
                <pass-on-log-filter></pass-on-log-filter>
                <div *ngIf="passOnLogService.canEdit()" class="col-sm-3">
                    <button type="button"
                            class="btn btn-w-m btn-primary pull-right"
                            (click)="passOnLogService.isPassOnLogModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Log
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allPassOnLogs'" [ngClass]="{'sk-loading': passOnLogService.spinnerShow}">
                    <pass-on-log-list></pass-on-log-list>
                </tab-item>
                <pagination *ngIf="passOnLogService.data.allPassOnLogs.total && urlService.queryParams['page']"
                            [total]="passOnLogService.data['allPassOnLogs'].total">
                </pagination>
                <spinner [spinnerShow]="passOnLogService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
        <div class="animated animated-directory slideInRight detailed-view dv-sidebar">
            <pass-on-log-detailed-view *ngIf="passOnLogService.showDetailedView"></pass-on-log-detailed-view>
        </div>
    </div>
</div>

<pass-on-log-modal *ngIf="passOnLogService.isPassOnLogModalShow"></pass-on-log-modal>
<view-pass-on-log-modal *ngIf="passOnLogService.isViewPassOnLogModalShow"></view-pass-on-log-modal>
<pass-on-log-history *ngIf="passOnLogService.isPassOnLogHistoryModalShow"></pass-on-log-history>
<pass-on-log-status-history *ngIf="passOnLogService.isPassOnLogStatusHistoryModalShow"></pass-on-log-status-history>



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log.component.html